import { Component, ElementRef, OnInit } from '@angular/core';
import { StsCmsService } from '../../../services/sts-cms-service.service';
import StsFooterModel from '../../../models/sts-footer.model';
import StsLink from '../../../models/sts-link.model';
import { environment } from 'environments/environment.prod';
import { StsDialogFactoryService } from 'app/services/sts-dialog-factory.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

declare let ua_track_event: Function;
declare let ua_record_page_view: Function;

@Component({
  selector: 'app-sts-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public showDialog: boolean;
  public dialogueItem: StsLink;
  public currentYear: number = (new Date()).getFullYear();
  public timerJob: any;
  public closeWindowJob: any;
  public footerModel: StsFooterModel;
  public htmlContent: SafeHtml;
  public version: any;

  constructor(private cmsService: StsCmsService, private dialogFactory: StsDialogFactoryService, private sanitizer: DomSanitizer, private elementRef: ElementRef) {
    this.version = environment.version;
    this.footerModel = new StsFooterModel();
  }

  ngOnInit() {
    this.cmsService.getFooter().subscribe(a => {
      this.footerModel = a;
    });
  }

  public getCurrentLink() {
    return this.dialogueItem ? this.dialogueItem.href : '';
  }

  private setFocusToIframe() {
    let frame = (document.getElementById('iframeAbout') as HTMLIFrameElement);
    frame.contentWindow.focus();
    frame.contentWindow.addEventListener("load", (event) => { document.getElementById('iframe-loader').style.display = "none"; });
    frame.contentWindow.addEventListener("DOMContentLoaded", (event) => { document.getElementById('iframe-loader').style.display = "none"; });
    frame.contentWindow.addEventListener("ready", (event) => { document.getElementById('iframe-loader').style.display = "none"; });
    frame.contentWindow.onload = (event) => { document.getElementById('iframe-loader').style.display = "none"; };
    document.getElementById('iframe-loader').style.display = "block";
    const inputArray = ['a', 'input', 'button', 'router-outlet']
    inputArray.forEach(elementA => {
      const nodeList = document.querySelectorAll(elementA);
      nodeList.forEach(element => {
        element.setAttribute('tabindex', '-1');
      });
    });
    let modalClose = document.getElementById('modalClose');
    modalClose.removeAttribute('tabindex');
    let modalCloseIcon = document.getElementById('modalCloseIcon');
    modalCloseIcon.removeAttribute('tabindex');
    clearTimeout(this.timerJob);
    this.closeWindowJob = setTimeout(() => {
      let innerframe = (document.getElementById('iframeAbout') as HTMLIFrameElement);
      if (innerframe.innerHTML.length > 1) {
        document.getElementById('iframe-loader').style.display = "none";
        clearTimeout(this.closeWindowJob);
      }
    }, 10);
  }

  public click(item: StsLink): boolean {
    if (typeof ua_record_page_view != "undefined")
      ua_record_page_view(item.title);
    if (item.type !== 'iframe') {
      window.open(item.href, item.target);
    } else {
      this.dialogueItem = item;
      this.showDialog = item != null;
      this.htmlContent = null;
      setTimeout(() => {
        document.getElementById('iframe-loader').style.display = "block";
        this.dialogFactory.getHtmlContent(this.dialogueItem.href)
          .subscribe(
            (response) => {
              document.getElementById('iframe-loader').style.display = "none";
              const bodyRegex = /<body[^>]*>((.|[\n\r])*)<\/body>/im;
              const match = bodyRegex.exec(response);
              if (match && match.length > 1) {
                this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(match[1]);
              } else {
                console.error('Body element not found in the HTML string');
              }
            },
            (error) => {
              console.error('Error fetching HTML:', error);
              document.getElementById('iframe-loader').style.display = "none";
            }
          );
      }, 10);
    }
    return false;
  }

  public socialLinkClick(item: StsLink): boolean {
    if (typeof ua_track_event != "undefined")
      ua_track_event('Login Page Actions', 'External Link', item.href);
    return true;
  }
}